import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreenBorderdTick = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 43,
	viewBox: "0 0 35 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 19.3306,
			cy: 6.5,
			rx: 2.68999,
			ry: 2.5,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 23.891,
			cy: 29.5,
			rx: 3.76599,
			ry: 3.5,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 19.1252,
			cy: 19,
			rx: 12.0783,
			ry: 12,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.4693,
			cy: 36.5,
			rx: 2.53176,
			ry: 2.5,
			fill: "#2DAB77"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 29.9346,
			cy: 42,
			rx: 1.0127,
			ry: 1,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24.8721,
			cy: 1,
			rx: 1.0127,
			ry: 1,
			fill: "#2DAB77"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 29C19.5 29 24 24.5 24 19C24 13.5 19.5 9 14 9C8.5 9 4 13.5 4 19C4 24.5 8.5 29 14 29Z",
			stroke: "#068F61",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 19.0019L12.58 21.8319L18.25 16.1719",
			stroke: "#068F61",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgGreenBorderdTick;
